module.exports = __webpack_public_path__ + "static/media/coin-plant-growth-blur2.6d52a847.png";